module.exports = __webpack_public_path__ + "img/Yaad-Group-TM.ec3e7685.svg";